import tips from './tips'
import copay from './copay'
import delivery from './delivery'

export default {
  'approve-type': {
    'face-2-face-id-required': {
      label: '面对面身份证和签名要求',
      description_1: '处方仅送达指定患者。收件人需提供身份证和签名，身份证姓名必须与收件人一致。',
      description_2: '司机在送达时会拍摄患者身份证和门口的照片。',
    },
    'face-2-face-not-required': {
      label: '不要求面对面签名',
      description: '签名由与患者同住的任何18岁以上成年人提供。司机会拍摄患者门口的照片。',
    },
    'face-2-face-required': {
      label: '要求面对面签名',
      description: '签名由与患者同住的任何人提供。司机会拍摄患者门口的照片。',
    },
    'non-contract-delivery': {
      label: '无接触配送',
      description: '司机会将包裹放在门口并拍照，不进行面对面配送。',
    },
    'online-signature': {
      label: '在线签名',
      description_1: '司机会将处方放在门口并拍照，',
      description_2: '仅当收件人在配送前在线签名时有效。没有在线签名时，配送方式将',
      description_3: '按“要求面对面签名”进行。',
    },
    'signature-optional': {
      label: '签名可选',
      description: '司机会尝试面对面配送。如果无人接收，司机会将包裹放在门口并拍照。',
    },
  },
  tips,
  copay,
  delivery,
  wait: '请稍候...',
  'promised-eta': '预计送达时间:',
  reschedule: '重新安排/更改地址',
}
